export default __webpack_public_path__ + "static/media/Principal_App_icon-1.c5ce3ad2.svg";